module.exports = __webpack_public_path__ + "static/dcom3-1024x850-e2403ee6ea0179af8fa55cd0d10685d1.png";